module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Commodity Details")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', {
    staticClass: "align-items-end"
  }, [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-row', [_c('b-col', [_c('label', [_vm._v("Item Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "itemName",
      "name": "itemName"
    },
    model: {
      value: (_vm.commodityModal.itemName),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "itemName", $$v)
      },
      expression: "commodityModal.itemName"
    }
  }), _vm._v(" "), (!_vm.commodityModal.itemName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.itemName))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-row', [_c('b-col', [_c('label', [_vm._v("HSN Code "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "hsnCode",
      "name": "hsnCode"
    },
    model: {
      value: (_vm.commodityModal.hsnCode),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "hsnCode", $$v)
      },
      expression: "commodityModal.hsnCode"
    }
  }), _vm._v(" "), (!_vm.commodityModal.hsnCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.hsnCode))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "0.3rem"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addCommodity
    }
  }, [_vm._v(_vm._s(_vm.commodityModal.commodityNewId != "" ? "Update" : "Add"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Item Name HSN Code"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getData('Excel')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExcelBtnName) + "\n                        "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.NewComodityMaster,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "sn",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "itemName",
      fn: function(row1) {
        return [_c('span', [_vm._v(" " + _vm._s(row1.item.itemName))])]
      }
    }, {
      key: "action",
      fn: function(row2) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editLocation(row2.item)
            }
          }
        }, [_vm._v("Update")])]
      }
    }, {
      key: "isCommodityActive",
      fn: function(row3) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row3.item.commodityNewId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row3.item.commodityNewId,
            "name": "approval",
            "value": row3.item.isCommodityActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row3.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row3.item.isCommodityActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row3.item.commodityNewId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row3.item.isCommodityActive == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a7d6638","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/newcommodityMaster.vue
// module id = 2714
// module chunks = 0